import { mdiArrowRight, mdiLockOpenVariantOutline } from '@mdi/js';
import Icon from '@mdi/react';
import get from 'lodash/get';
import React from 'react';
import { useSelector } from 'react-redux';
import { scroller } from 'react-scroll';
import {
  contentClick,
  loadMoreInteraction,
  subscribeClick,
} from '../../../../helpers/datalayer-utils';
import { getHeadline, getStorySlug } from '../../../../helpers/utils';
import { BQLink } from '../../../atoms/bqlink';
import CardImage from '../../../atoms/cardimage';
import { FourStarIcon } from '../../../atoms/material-icons';
import ShineButton from '../../../atoms/shine-button';
import './premium-stories.m.css';

const PremiumStories = ({ sotries, isSubscriber }) => {
  const userData = useSelector((state) => get(state, ['userData']));
  const pageType = useSelector((state) => get(state, ['qt', 'pageType']));
  const storyList = sotries?.items
    ?.filter((c) => c.type === 'story')
    .map(({ story }) => story)
    .slice(0, 3);
  const firstObj = get(storyList, '[0]');
  const secondObj = get(storyList, '[1]');
  const thirdObj = get(storyList, '[2]');

  const handleClick = () => {
    subscribeClick(userData, pageType, 'Premium');
    scroller.scrollTo('subscription-home', {
      duration: 500,
      delay: 100,
      smooth: 'easeInOutQuart',
    });
  };

  const link = getStorySlug(sotries) ? getStorySlug(sotries) : '/premium';

  return (
    <div styleName="premium-container" className="container">
      <div styleName="headerText">
        <div styleName="head-icon">
          <FourStarIcon color="#ffffff" size="29px" />
        </div>
        <div styleName="heading">Premium</div>
      </div>
      {sotries !== null && (
        <div styleName="three-stories-wrap" className="container">
          <div onClick={() => contentClick(userData, firstObj, pageType)}>
            <BQLink styleName="story first-story" href={getStorySlug(firstObj)} target="_blank">
              <CardImage
                story={firstObj}
                imageType="image16x9"
                aspectRatio={[16, 9]}
                isLazy={true}
                imageRounded="none"
              />
              <div styleName="first-text">
                <div styleName="premium-icon">
                  <FourStarIcon color="#CE9445" size="18px" />
                </div>
                <span>{getHeadline(firstObj)}</span>
              </div>
            </BQLink>
          </div>
          <div onClick={() => contentClick(userData, secondObj, pageType)}>
            <BQLink styleName="story second-story" href={getStorySlug(secondObj)} target="_blank">
              <div styleName="headline">
                {getHeadline(secondObj)}
                <div styleName="triangel first" className="desktop-only"></div>
              </div>
              <CardImage
                story={secondObj}
                imageType="image16x9"
                aspectRatio={[16, 9]}
                isLazy={true}
                imageRounded="none"
              />
              <div styleName="premium-icon">
                <FourStarIcon color="#CE9445" size="18px" />
              </div>
            </BQLink>
          </div>
          <div onClick={() => contentClick(userData, thirdObj, pageType)}>
            <BQLink styleName="story third-story" href={getStorySlug(thirdObj)} target="_blank">
              <div styleName="headline">
                {getHeadline(thirdObj)}
                <div styleName="triangel" className="desktop-only"></div>
              </div>
              <CardImage
                story={thirdObj}
                imageType="image16x9"
                aspectRatio={[16, 9]}
                isLazy={true}
                imageRounded="none"
              />
              <div styleName="premium-icon">
                <FourStarIcon color="#CE9445" size="18px" />
              </div>
            </BQLink>
          </div>
        </div>
      )}
      <div styleName="button-wrap" className="container">
        {isSubscriber === false && isSubscriber !== null && (
          <div styleName="report-btn" className="container" onClick={() => handleClick()}>
            <ShineButton
              className="shine-button"
              size="medium"
              label="Subscribe to Unlock"
              icon="left"
              rounded="full"
            >
              <Icon path={mdiLockOpenVariantOutline} size="18px" />
            </ShineButton>
          </div>
        )}
        <BQLink className="container" styleName="more-btn" href={link} target="_blank">
          <div
            styleName="btn"
            onClick={() => loadMoreInteraction('More from Premium', userData, pageType, 'Premium')}
          >
            More from Premium &nbsp;
            <Icon path={mdiArrowRight} size="20px" color="#725E42" />
          </div>
        </BQLink>
      </div>
    </div>
  );
};

export default PremiumStories;
